import { Button, ButtonProps } from '@chakra-ui/react';

export function PageButton({
    pageNumber,
    ...props
}: { pageNumber: number } & ButtonProps) {
    return (
        <Button
            variant="ghost"
            aspectRatio="1"
            key={pageNumber}
            value={pageNumber}
            colorScheme="muted"
            fontWeight="initial"
            _active={{
                bg: 'secondary.500',
                color: 'white',
                fontWeight: 'bold',
            }}
            {...props}
        >
            {pageNumber}
        </Button>
    );
}
